<section class="edit-profile-section">
    <header class="row page-header">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <h2 class=title>Editing</h2>
                </div>
                <div class="col-md-6 text-end">
                    <button [disabled]="!(userProfileForm.valid || (userProfileForm.dirty && userProfileForm.valid))" type="submit" (click)="saveProfile()" class="btn btn-success">
                        SAVE PROFILE
                    </button>
                    <button type="submit" (click)="onCancel()" class="btn btn-success">CANCEL</button>
                </div>

            </div>
        </div>
    </header>
    <main>
        <div class="container">
            <div class="form-section">

                <form [formGroup]="userProfileForm">

                    <div class="row">
                        <div class="col-md-2 text-center">
                            <sp-profileimage isProfileImage="true" isLarge="true" updatedImage="{{image}}"></sp-profileimage>
                        </div>

                        <div class="col-md-4 col-sm-10">

                            <div class="form-group top-buffer-20">
                                <label for="firstName">First Name</label><span class="required">*</span>
                                <input type="text" id="firstName" formControlName="firstName" pattern="[a-zA-Z0-9\.\-\s_]{0,50}" maxlength="50" minlength="3" class="form-control"
                                />
                                <span [hidden]="firstName.untouched || firstName.valid" class="red">
                                    <span *ngIf="firstName.errors && firstName.errors.pattern">Only 'Alphanumeric', 'underscore' and 'Dash' characters allowed</span>
                                </span>
                            </div>

                            <div class="form-group top-buffer-20">
                                <label for="lastName">Last Name</label><span class="required">*</span>
                                <input type="text" id="lastName" formControlName="lastName" pattern="[a-zA-Z0-9\.\-\s_]{0,50}" maxlength="50" minlength="3" class="form-control" />
                                <span [hidden]="lastName.untouched || lastName.valid" class="red">
                                    <span *ngIf="lastName.errors && lastName.errors.pattern">Only 'Alphanumeric', 'underscore' and 'Dash' characters allowed</span>
                                </span>
                            </div>

                            <div class="form-group top-buffer-20">
                                <label for="phone">Phone</label>
                                <input type="text" id="phone" formControlName="phone" class="form-control" pattern="((001[ -]?)?(\d{3}[ -]?\d{3}[ -]?\d{4}))?" />
                                <span [hidden]="phone.untouched || phone.valid" class="red">
                                    <span *ngIf="phone.errors && phone.errors.pattern">Phone should be like xxx xxx xxxx </span>
                                </span>
                            </div>

                            <div class="form-group top-buffer-20">
                                <label for="email">Email</label><span class="required">*</span>
                                <input type="email" id="email" formControlName="email" required class="form-control" />
                                <span [hidden]="email.untouched || email.valid" class="red">
                                    <span *ngIf="email.errors && email.errors.required">Email is required</span>
                                    <span *ngIf="email.errors && email.errors.pattern">Email should be like email&#64;server.com</span>
                                </span>
                            </div>

                            <div class="form-group top-buffer-20">
                                <label>Password</label>
                                <br />
                                <a [routerLink]="['/useraccount/user/changepassword']">Update password</a>
                            </div>

                            <div class="form-group top-buffer-20">
                                <label>Joined</label>
                                <br />
                                <label>{{joinedOn | date: 'MMM dd, yyyy'}}</label>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </main>
</section>
